import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { orgUiPath } from '@/core/api';
import { autoBootstrapWorkspace } from '@/core/workspaceBootstrap';
import { Spinner } from '@/components/primitives/Spinner';

/** Runs ``POST /setup`` then enters the new workspace (replaces manual ``/setup`` page). */
export function AutoBootstrapGate() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    autoBootstrapWorkspace()
      .then((orgId) => {
        if (cancelled) return;
        navigate(orgUiPath(orgId, '/'), { replace: true });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setError(err instanceof Error ? err.message : 'Workspace setup failed');
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (error) {
    return (
      <div className="aspectly:flex aspectly:h-screen aspectly:flex-col aspectly:items-center aspectly:justify-center aspectly:gap-4 aspectly:bg-surface aspectly:px-6">
        <p className="aspectly:text-on-surface-variant aspectly:text-sm">{error}</p>
      </div>
    );
  }

  return (
    <div className="aspectly:flex aspectly:h-screen aspectly:items-center aspectly:justify-center aspectly:bg-surface">
      <Spinner size="lg" />
    </div>
  );
}
